module.exports = __webpack_public_path__ + "media/assets/img/flags/pt-BR-6d08e0dcdad5dad61bfe91e9fd10ec43.png";